import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["selection", "cityInput", "autocomplete", "warning", "submitButton"]
    static values = {
        selectedCities: Array
    }

    connect() {
        // Load existing cities from the hidden field if any
        if (this.cityInputTarget.value) {
            this.selectedCitiesValue = JSON.parse(this.cityInputTarget.value)
        } else {
            this.selectedCitiesValue = []
        }

        this.updateCityList()  // Re-render the city list
        this.updateHiddenFields()
        this.element.addEventListener("autocomplete.change", this.handleCitySelection.bind(this))
    }

    handleCitySelection(event) {
        const { textValue: cityName, lat, long } = event.detail
        if (!this.selectedCitiesValue.some(city => city.name === cityName)) {
            this.selectedCitiesValue = [...this.selectedCitiesValue, { name: cityName, latitude: lat, longitude: long }]
            this.updateCityList()
            this.updateHiddenFields()
        }
        this.clearInput()
        this.clearWarning()
    }

    updateCityList() {
        this.selectionTarget.innerHTML = this.selectedCitiesValue.map(city => `
    <span data-city="${city.name}" class="inline-flex flex-nowrap items-center gap-x-0.5 rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10">
  ${city.name}
  <button type="button"  data-action="click->multicity#removeCity" data-city="${city.name}" class="group relative -mr-1 h-3.5 w-3.5 rounded-sm hover:bg-gray-500/20">
    <span class="sr-only">Remove</span>
    <svg viewBox="0 0 14 14" class="h-3.5 w-3.5 stroke-gray-600/50 group-hover:stroke-gray-600/75">
      <path d="M4 4l6 6m0-6l-6 6" />
    </svg>
    <span class="absolute -inset-1"></span>
  </button>
</span>
    `).join('')
    }


    clearWarning() {
        this.warningTarget.innerHTML = ""
    }


    clearInput() {
        this.autocompleteTarget.value = ""
    }

    removeCity(event) {
        const cityToRemove = event.currentTarget.dataset.city
        this.selectedCitiesValue = this.selectedCitiesValue.filter(city => city.name !== cityToRemove)
        this.updateCityList()
        this.updateHiddenFields()
    }

    updateHiddenFields() {
        this.cityInputTarget.value = JSON.stringify(this.selectedCitiesValue)
        if (this.cityInputTarget.value == "[]") {
            this.handleEmptyCityInput()
        } else {
            if ((this.hasSubmitButtonTarget)) {
                this.submitButtonTarget.disabled = false;
            }
            this.clearWarning()
        }
    }

    handleEmptyCityInput() {
        if (this.warningTarget.innerHTML.trim() === '') {
            this.warningTarget.innerHTML = `<p class="mt-2 text-sm text-gray-500">Veuillez sélectionner au moins une ville.</p>`;
        }
        if ((this.hasSubmitButtonTarget)) {
            this.submitButtonTarget.disabled = true;
        }
    }
}